/**
 * 路由
 */
import { RouterOptions } from 'vue-router'

const config: RouterOptions = {
  routes: [
    { // 默认打开页面
      path: '/',
      redirect: '/index',
      // beforeEnter: checkIsLogin,
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('../pages/auth/index.vue'), // 应用授权
    },
  ],
}

export default config
